import whenDomReady from 'when-dom-ready';
import Plyr from 'plyr';
const wrap = (toWrap, wrapper) => {
    wrapper = wrapper || document.createElement('div');
    const parent = toWrap.parentNode;
    if (!parent)
        return;
    parent.appendChild(wrapper);
    wrapper.appendChild(toWrap);
    return;
};
const unwrap = (wrapper) => {
    const docFrag = document.createDocumentFragment();
    while (wrapper.firstChild) {
        const child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
    }
    const parent = wrapper.parentNode;
    if (!parent)
        return;
    parent.replaceChild(docFrag, wrapper);
    return;
};
function initialise() {
    const lightboxVideo = document.querySelector('.js-video-lightbox');
    if (!lightboxVideo) {
        return;
    }
    const lightboxAfterVideoContent = lightboxVideo.querySelector('.video-lightbox__after-video-content');
    if (!lightboxAfterVideoContent) {
        return;
    }
    // video handling
    const videoElement = lightboxVideo.querySelector('.video-lightbox__video');
    if (!videoElement) {
        return;
    }
    const play = document.querySelector('.js-video-lightbox-button');
    if (play) {
        console.log('button');
        play.addEventListener('click', () => {
            lightboxVideo.style.display = 'flex';
            // TODO - replay not working properly yet
            if (!hasVideoPlayed() && !isVideoPlaying()) {
                initialiseVideoElement(lightboxVideo, videoElement);
                lightboxVideo.classList.add('js-video-lightbox-playing');
                lightboxVideo.classList.add('js-video-lightbox-is-active');
            }
            else {
                lightboxVideo.classList.add('js-video-lightbox-after-video-is-active');
            }
            if (!hasVideoPlayed()) {
                lightboxVideo.classList.add('js-video-lightbox-is-active');
            }
            else {
                lightboxVideo.classList.add('js-video-lightbox-after-video-is-active');
            }
            const contentHolder = document.createElement('div');
            contentHolder.className = 'lightbox__content-holder';
            wrap(lightboxVideo, contentHolder);
            const lightbox = document.createElement('div');
            lightbox.className = 'lightbox__content lightbox__content--cta-video';
            wrap(contentHolder, lightbox);
            const overlay = document.createElement('div');
            overlay.className = 'lightbox__overlay';
            contentHolder.appendChild(overlay);
        });
    }
}
export function initialiseCloseElement(lightboxVideo, plyr) {
    if (!lightboxVideo) {
        return;
    }
    const close = lightboxVideo.querySelector('.lightbox__close');
    if (close) {
        close.addEventListener('click', () => {
            plyr.pause();
            lightboxVideo.classList.remove('js-video-lightbox-is-active');
            lightboxVideo.classList.remove('js-video-lightbox-after-video-is-active');
            lightboxVideo.classList.remove('js-video-lightbox-playing');
            lightboxVideo.style.display = 'none';
            const contentHolder = document.querySelector('.lightbox__content-holder');
            const overlay = document.querySelector('.lightbox__overlay');
            const lightbox = document.querySelector('.lightbox__content--cta-video');
            if (contentHolder) {
                contentHolder.removeChild(overlay);
                unwrap(contentHolder);
            }
            if (lightbox) {
                unwrap(lightbox);
            }
        });
    }
}
export function initialiseReplayElement(lightboxVideo, plyr) {
    if (!lightboxVideo) {
        return;
    }
    const replayButton = document.querySelector('.js-video-lightbox__button-replay');
    if (replayButton) {
        replayButton.addEventListener('click', () => {
            switchVideoContent(lightboxVideo);
            if (!isVideoPlaying()) {
                plyr.play();
            }
        });
    }
}
export function initialiseVideoElement(lightboxVideo, videoElement) {
    if (!lightboxVideo) {
        return;
    }
    const player = videoElement.querySelector('.js-video-lightbox-player');
    if (!player) {
        return;
    }
    const videoURL = player.dataset.embed;
    if (!videoURL) {
        console.error('Video URL is undefined');
        return;
    }
    const video = document.createElement('video');
    video.setAttribute('controls', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('src', videoURL); // Assuming the MP4 URL is stored in data-embed
    video.addEventListener('ended', () => {
        const lightboxAfterVideoContent = document.querySelector('.video-lightbox__after-video-content');
        if (!lightboxAfterVideoContent) {
            return;
        }
        switchAfterVideoContent(lightboxAfterVideoContent);
    });
    player.innerHTML = '';
    player.appendChild(video);
    const plyr = new Plyr(video);
    if (!isVideoPlaying()) {
        plyr.play();
    }
    initialiseCloseElement(lightboxVideo, plyr);
    initialiseReplayElement(lightboxVideo, plyr);
}
export function switchAfterVideoContent(lightboxAfterVideoContent) {
    const lightboxVideo = document.querySelector('.js-video-lightbox');
    if (!lightboxVideo) {
        return;
    }
    lightboxVideo.classList.add('js-video-lightbox-after-video-content-is-active');
    lightboxVideo.classList.add('js-video-lightbox-played');
    lightboxVideo.classList.remove('js-video-lightbox-playing');
    const video = document.querySelector('.video-lightbox__video');
    video.style.display = 'none';
    lightboxAfterVideoContent.style.display = 'block';
}
export function switchVideoContent(lightboxVideo) {
    const lightboxAfterVideoContent = document.querySelector('.video-lightbox__after-video-content');
    if (!lightboxAfterVideoContent) {
        return;
    }
    lightboxVideo.classList.remove('js-video-lightbox-after-video-content-is-active');
    lightboxVideo.classList.remove('js-video-lightbox-played');
    const video = document.querySelector('.video-lightbox__video');
    if (!video) {
        return;
    }
    video.style.display = 'block';
    lightboxAfterVideoContent.style.display = 'none';
}
export function hasVideoPlayed() {
    let hasVideoPlayed = false;
    const lightboxVideoPlayed = document.querySelector('.js-video-lightbox-played');
    if (lightboxVideoPlayed) {
        hasVideoPlayed = true;
    }
    return hasVideoPlayed;
}
export function isVideoPlaying() {
    let isVideoPlaying = false;
    const lightboxVideoPlaying = document.querySelector('.js-video-lightbox-playing');
    if (lightboxVideoPlaying) {
        isVideoPlaying = true;
    }
    return isVideoPlaying;
}
whenDomReady().then(initialise);
